var routerActions = require('react-router-redux').routerActions;
var constants = require('../constants');
var api = require('../../../utils/api');
var utils = require('../regUtils');
var authCurrentUserActions = require('./auth-current-user');
var educationActions = require('../../education/actions/education');
var authActions = require('./auth-login');
var commonActions = require('../../common/actions/common');

var Registration = (function() {

    var _signUpSuccess = function(data, analyticsLabelSuffix){
        return {
            type: constants.AUTH_REGISTER_SUCCESS,
            data: data,
            meta: {
                analytics: {
                    eventType: constants.AUTH_REGISTER_SUCCESS,
                    actionValue: 'Success',
                    labelValue: 'Email' + (analyticsLabelSuffix ? ' ' + analyticsLabelSuffix : '')
                }
            }
        };
    }

    var _signUpError = function(error, analyticsLabelSuffix) {
        return {
            type: constants.AUTH_REGISTER_ERROR,
            errors: error.data,
            meta: {
                analytics: {
                    eventType: constants.AUTH_REGISTER_ERROR,
                    actionValue: 'Failure',
                    labelValue: 'Email' + (analyticsLabelSuffix ? ' ' + analyticsLabelSuffix : '')
                }
            }
        };
    }

    var _validationError = function(error){
        return {
            type: constants.AUTH_REGISTER_ERROR,
            errors: error
        }
    }

    var _clearRegError = function() {
        return {
            type: constants.CLEAR_REGISTER_ERROR
        };
    }

    var _signUp = function(firstName, lastName, email, password, gender, dob, postalCode, redirectUrl, analyticsLabelSuffix) {
        return function(dispatch, getState) {
            utils.validate(firstName, lastName, email, password, gender, dob, postalCode)
                .then(function(result) {
                    if (result === true) {
                        api.post('/authproxy', {
                                "username": email,
                                "password": password,
                                "profile": {
                                    "firstName": firstName,
                                    "lastName": lastName,
                                    "sex": gender,
                                    "dateOfBirth": dob,
                                    "postalCode": postalCode,
                                    "contactForTrials": true
                                }
                            })
                            .then(function(data) {
                                dispatch(_signUpSuccess(data, analyticsLabelSuffix));
                                dispatch(authActions.loginSuccess(data, false));
                                dispatch(authCurrentUserActions.fetchCurrentUser(data.access_token));
                                if(redirectUrl !== 'no-redirect'){ // 'no-redirect' is used for quick register/login (popup)
                                    if(redirectUrl){
                                        dispatch(routerActions.replace(redirectUrl));
                                    }else{
                                        dispatch(routerActions.replace('/surveys/promis'));
                                    }
                                }
                                dispatch(educationActions.setThanksRegisteringMessage());
                            })
                            .catch(function(error) {
                                if(error.response){
                                    dispatch(_signUpError(error.response, analyticsLabelSuffix));
                                }else{
                                    dispatch(commonActions.setGenericError('', error.message));
                                }
                            })
                    } else {
                        dispatch(_validationError(result));
                    }
                })
        };
    }

    var _partialSignUp = function (firstName, lastName, email, gender, dob, postalCode, redirectUrl, analyticsLabelSuffix) {
        return function (dispatch, getState) {
            // create temporary password
            // since password is not an input field captured by PartialRegisterBox component
            // but required for validation and storing in db
            var tempPassword = "MTHCustomCl!nic";

            utils.validate(firstName, lastName, email, tempPassword, gender, dob, postalCode)
                .then(function (result) {
                    if (result === true) {
                        api.post('/authproxy', {
                            "username": email,
                            "password": tempPassword,
                            "profile": {
                                "firstName": firstName,
                                "lastName": lastName,
                                "sex": gender,
                                "dateOfBirth": dob,
                                "postalCode": postalCode,
                                "contactForTrials": true,
                                // custom clinic user registrants are flagged as pending users
                                "isPending": true,
                            }
                        })
                            .then(function (data) {
                                dispatch(_signUpSuccess(data, analyticsLabelSuffix));
                                dispatch(authActions.loginSuccess(data, false));
                                dispatch(authCurrentUserActions.fetchCurrentUser(data.access_token));
                                if (redirectUrl !== 'no-redirect') { // 'no-redirect' is used for quick register/login (popup)
                                    if (redirectUrl) {
                                        dispatch(routerActions.replace(redirectUrl));
                                    } else {
                                        dispatch(routerActions.replace('/surveys/promis'));
                                    }
                                }
                                dispatch(educationActions.setThanksRegisteringMessage());
                            })
                            .catch(function (error) {
                                if (error.response) {
                                    dispatch(_signUpError(error.response, analyticsLabelSuffix));
                                } else {
                                    dispatch(commonActions.setGenericError('', error.message));
                                }
                            })
                    } else {
                        dispatch(_validationError(result));
                    }
                })
        };
    }

    return {
        signUp: _signUp,
        clearRegError: _clearRegError,
        partialSignUp: _partialSignUp,
    }
})();

module.exports = Registration;



// WEBPACK FOOTER //
// ./src/common/modules/auth/actions/auth-register.js